import { useQuery } from 'react-query';

import { UploadFailureReason } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export type FileDeletionType = 'staged' | 'submitted';

/**
 * File history stats DTO - matches backend FileHistoryStatsDto
 */
export interface FileHistoryStats {
  totalAttempted: number;
  totalSuccessful: number;
  totalFailed: number;
  uploadCount: number;
  failuresByReason: Record<UploadFailureReason, number>;
  deletionsByReason: Record<FileDeletionType, number>;
  processed: number;
  notProcessed: number;
  stagedFiles: number;
  submittedFiles: number;
}

export const useGetFileHistoryStats = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<FileHistoryStats>(
    [QueryEntity.FileHistoryStats, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/file-history-stats`, fetchConfigGET).then(
        (res) => {
          return res.json();
        },
      );
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
